import { useState, useEffect } from 'react'
import i18n from '../../../i18n'
import { bruktbilfinansieringAPI } from '../../../services/api'
import type { KlasserClassDetailsResponse } from '../../../types/bruktbilfinansiering'

interface Filters {
  startDate: string
  endDate: string
  varebil?: boolean
  buyerPostnummer?: string
  dealerPostnummer?: string
}

export function useClassDetails(
  bankOrgNr: string,
  classLabel: string,
  filters: Filters,
) {
  const [data, setData] = useState<KlasserClassDetailsResponse | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!bankOrgNr || !classLabel) return
    setLoading(true)
    setError(null)
    bruktbilfinansieringAPI.getClassDetails(bankOrgNr, classLabel, {
      start_date: filters.startDate,
      end_date: filters.endDate,
      varebil: filters.varebil,
      buyer_postnummer: filters.buyerPostnummer,
      dealer_postnummer: filters.dealerPostnummer,
    })
      .then(res => setData(res.data))
      .catch(e => setError(e instanceof Error ? e.message : i18n.t('errors.classDetails', { ns: 'bbf' })))
      .finally(() => setLoading(false))
   
  }, [bankOrgNr, classLabel, filters.startDate, filters.endDate, filters.varebil, filters.buyerPostnummer, filters.dealerPostnummer])

  return { data, loading, error }
}
